<button
  [id]="id"
  (click)="onClick.emit($event)"
  [disabled]="disabled"
  [ngStyle]="{width: width}"
  class="core-button-flex"
  pButton
  pRipple>
  <fa-icon
    *ngIf="icon"
    [icon]=icon
    [ngClass]="icon && text ? 'core-button-space-between-icon-and-text' : ''">
  </fa-icon>
  {{text}}
</button>
